import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import { useTranslation } from "react-i18next";
import ChangePhoneForm from "../../Forms/ChangePhoneForm/ChangePhoneForm";

const ChangeProfilePhoneModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:editProfile"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);

  const formName = "ChangePhoneForm";
  const { handleHide, show, phone } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="submit"
          type="subbmit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"500px"}
      height={"280px"}
      onClose={handleHide}
      header={t("global:profile.changePhone")}
      buttons={buttons()}
      steps={steps}
    >
      <ChangePhoneForm
        isSubmit={isSubmit}
        steps={steps}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        phone={phone}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ChangeProfilePhoneModal" })(
  ChangeProfilePhoneModal
);
